import {Grid2 as Grid, TextField} from "@mui/material";
import React from "react";

interface FormInputProps {
  name: string;
  label: string;
  values: Record<string, any>;
  onChange: (name: string, value: string) => void;
  size?: number | "grow" | "auto";
}


export default function FormInput({name, label, values, size = 12, onChange}: FormInputProps) {
  return <Grid size={size}>
    <TextField
      fullWidth
      label={label}
      value={values[name]}
      name={name}
      data-testid={name}
      slotProps={{inputLabel: {shrink: true}}}
      onChange={e => onChange(name, e.target.value)} />
  </Grid>;
}
